import SwapPanel from '@/views/WorkScheduleSwap/SwapPanel'

let routes = {
    path: '/WorkSchedulesSwap',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/WorkSchedulesSwap',
            name: 'Trocas de Escala',
            component: SwapPanel
        },
    ]
};

export default routes
